import { useContent } from '../ContentContext';
import { PageHero, SectionHead } from '../components/Common';

// Icons the live site uses on the highlight tiles, in order.
const HIGHLIGHT_ICONS = ['fa-award', 'fa-industry', 'fa-globe', 'fa-handshake'];

export default function CompanyProfile() {
  const { aboutHome = {}, companyHighlights = [], whyChooseList = [], company = {} } = useContent();

  return (
    <>
      <PageHero title="Company Profile" image={aboutHome.image} />

      {/* Who We Are — 50/50 image + copy */}
      <section>
        <div className="container profile-grid">
          <div className="profile-image">
            <img src={aboutHome.image} alt={company.name} />
          </div>
          <div className="profile-content">
            <span className="section-tag">Who We Are</span>
            <h2>{company.name}</h2>
            <p>{aboutHome.text}</p>
            <p>{company.about}</p>
          </div>
        </div>
      </section>

      {/* Company Highlights — 4 white tiles with big gold icons */}
      {companyHighlights.length ? (
        <section>
          <div className="container">
            <SectionHead title="Company Highlights" />
            <div className="highlight-grid">
              {companyHighlights.map((h, i) => (
                <div className="highlight-box" key={h}>
                  <i className={`fas ${HIGHLIGHT_ICONS[i % HIGHLIGHT_ICONS.length]}`} />
                  <h3>{h}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}

      {/* Why Choose Us — 2-up ticked cards on the grey band */}
      {whyChooseList.length ? (
        <section className="grey-bg">
          <div className="container">
            <SectionHead title="Why Choose Us" />
            <div className="why-company-grid">
              {whyChooseList.map((w) => (
                <div key={w}>
                  <i className="fas fa-check-circle" />
                  {w}
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}
